/*
 * Omaggi automatici nel carrello (DIR Store)
 * - Legge da sections/omaggi-dati.liquid quanti omaggi spettano (regole nel metaoggetto "regola_omaggio")
 * - Aggiunge/toglie le righe omaggio (proprietà nascosta _omaggio) per allineare il carrello
 * - Pubblica cart-update così il carrello a scomparsa si ridisegna
 * Il prezzo a 0 € lo applica lo sconto automatico Shopify collegato alla regola.
 */
(function () {
  if (window.__omaggiInit) return;
  window.__omaggiInit = true;

  var SOURCE = 'omaggi';
  var MAX_PASSI = 6;
  var running = false;
  var rerun = false;

  function jsonPost(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json();
    });
  }

  function leggiStato() {
    return fetch(window.routes.cart_url + '?section_id=omaggi-dati', { headers: { Accept: 'text/html' } })
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.getElementById('omaggi-json');
        return el ? JSON.parse(el.textContent) : null;
      });
  }

  // Restituisce la prossima operazione da fare (una alla volta) oppure null se il carrello è a posto.
  function prossimaOperazione(stato) {
    if (!stato || !stato.rules) return null;

    var spettanti = {}; // variantId -> numero omaggi
    var disponibili = {};
    stato.rules.forEach(function (r) {
      spettanti[r.v] = (spettanti[r.v] || 0) + r.e;
      disponibili[r.v] = r.a;
    });

    var varianti = Object.keys(spettanti);
    for (var i = 0; i < varianti.length; i++) {
      var v = Number(varianti[i]);
      var dovuti = spettanti[v];
      var righe = stato.lines.filter(function (l) {
        return l.v === v;
      });
      var totale = righe.reduce(function (s, l) {
        return s + l.q;
      }, 0);

      if (totale < dovuti && disponibili[v]) {
        return (function (variante, quantita) {
          return function () {
            return jsonPost(window.routes.cart_add_url + '.js', {
              items: [{ id: variante, quantity: quantita, properties: { _omaggio: '1' } }],
            });
          };
        })(v, dovuti - totale);
      }

      if (totale > dovuti) {
        // Togliamo solo le righe aggiunte automaticamente, mai quelle acquistate dal cliente.
        var auto = righe.filter(function (l) {
          return l.auto;
        });
        if (auto.length) {
          var riga = auto[0];
          var nuovaQ = Math.max(0, riga.q - (totale - dovuti));
          return (function (chiave, quantita) {
            return function () {
              return jsonPost(window.routes.cart_change_url + '.js', { id: chiave, quantity: quantita });
            };
          })(riga.k, nuovaQ);
        }
      }
    }
    return null;
  }

  function aggiornaIconaCarrello() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return Promise.resolve();
    return fetch(window.location.pathname + '?sections=cart-icon-bubble')
      .then(function (r) {
        return r.json();
      })
      .then(function (sections) {
        if (!sections['cart-icon-bubble']) return;
        var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var src = doc.querySelector('.shopify-section');
        if (src) bubble.innerHTML = src.innerHTML;
      })
      .catch(function () {});
  }

  function sincronizza() {
    if (running) {
      rerun = true;
      return;
    }
    running = true;
    var modificato = false;
    var passo = 0;

    function ciclo() {
      if (passo++ >= MAX_PASSI) return Promise.resolve();
      return leggiStato().then(function (stato) {
        var op = prossimaOperazione(stato);
        if (!op) return;
        modificato = true;
        return op().then(ciclo);
      });
    }

    ciclo()
      .then(function () {
        if (!modificato) return;
        return fetch(window.routes.cart_url + '.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE, cartData: cart });
            }
            return aggiornaIconaCarrello();
          });
      })
      .catch(function (e) {
        console.error('[omaggi]', e);
      })
      .finally(function () {
        running = false;
        if (rerun) {
          rerun = false;
          sincronizza();
        }
      });
  }

  function avvia() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (evento) {
        if (evento && evento.source === SOURCE) return;
        // non blocchiamo chi ha pubblicato l'evento
        setTimeout(sincronizza, 0);
      });
    }
    sincronizza();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia);
  } else {
    avvia();
  }
})();
